import { render, staticRenderFns } from "./InsightModal.vue?vue&type=template&id=5f5ad5e2&"
import script from "./InsightModal.vue?vue&type=script&lang=js&"
export * from "./InsightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports